import { render, staticRenderFns } from "./SimpleCamera.vue?vue&type=template&id=593598d4&scoped=true&"
import script from "./SimpleCamera.vue?vue&type=script&lang=js&"
export * from "./SimpleCamera.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCamera.vue?vue&type=style&index=0&id=593598d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593598d4",
  null
  
)

export default component.exports